<template>
  <div class="kab-20-home-exhibitors">
    <div class="md-layout md-alignment-center-center">
      <h1>Exhibitors</h1>
    </div>
    <div class="md-layout masters">
      <h2>Masters</h2>
      <div class="md-layout md-alignment-center-right">
        <div class="navigation accent">
          <md-icon>chevron_left</md-icon>
          <span @click="goToMasters">See more</span>
          <md-icon>chevron_right</md-icon>
        </div>
      </div>
      <hr class="horizontal-rule">
      <template v-for="(master, index) in masterData">
        <div
          :key="index"
          class="studio-card"
        >
          <div class="studio-image">
            <img
              alt="picture"
              :src="master.field_image"
            >
          </div>
          <h3 v-html="master.field_studio" />
        </div>
      </template>
    </div>

    <div class="md-layout apprentices">
      <h2>Apprentices</h2>
      <div class="md-layout md-alignment-center-right">
        <div class="navigation">
          <md-icon>chevron_left</md-icon>
          <span @click="goToApprentices">See more</span>
          <md-icon>chevron_right</md-icon>
        </div>
      </div>
      <hr class="horizontal-rule">
      <template v-for="(user, index) in apprenticeData">
        <div
          :key="index"
          class="apprentices-card"
        >
          <div class="apprentices-image">
            <img
              alt="picture"
              :src="user.field_image"
            >
          </div>
          <h3 v-html="user.title" />
          <h4>{{ user.field_studio }}</h4>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "Exhibitors",
  computed: {
    ...mapState([
      'apprentices',
      'masters'
    ]),
    apprenticeData() {
      return this.apprentices.slice(0, 5)
    },
    masterData() {
      return this.masters.slice(0, 5)
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        await Promise.all([
          this.$store.dispatch('getMasters'),
          this.$store.dispatch('getApprentices')
        ])
      } catch (error) {
        throw Error(error)
      }
    },
    goToMasters() {
      this.$router.push('/masters')
    },
    goToApprentices() {
      this.$router.push('/apprentices')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.kab-20-home-exhibitors {
  position: relative;
  top: -200px;
  margin-bottom: -149px;
  h1 {
    margin-top: -7px;
    margin-bottom: 29px; 
    font-size: 50px;
    font-weight: bold;
    line-height: 1.28;
    text-align: center;
    color: $color-black;
  }

  .masters {
    margin-top: 0px;
    margin-bottom: 0px;
    h2 {
      font-size: 21px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.48;
      letter-spacing: normal;
      color: #000000;
    }
  }

  .apprentices {
    @extend .masters;
  }

  .horizontal-rule {
    width: 100%;
    object-fit: contain;
    border: solid 1px #c2d1d9; 
  }
  .studio-card { 
    width: 186px;
    height: 188px;
    margin-top: 18px;
    background-color: $color-white;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;

    &:not(:last-child) {
      margin-right: 32px;
    }

    .studio-image {
      height: 151px;
      img {
        height: 151px;
      }
    }
    
    h3 {
      margin-top: 9px;
      margin-bottom: 9px; 
      font-size: 16px;
      font-weight: bold; 
      line-height: 1.25; 
      text-align: center;
      color: $color-black;
    }
  }
  .navigation {
    width: 120px;
    margin-top: 15px;
    .md-icon {
      color: $color-white;
    }
    span { 
      font-size: 14px;
      font-weight: bold; 
      color: #b42476;
      cursor: pointer;
    }
    &.accent {
      .md-icon {
        color: $color-black;
      }
    }
  }

  .apprentices-card {
    @extend .studio-card;
    border-radius: 7px;
    .apprentices-image {
      img {
        width: 92px;
        height: 92px;
        display: block;
        margin: auto;
        border-radius: 50%;
        border: 2px solid $color-primary;
        margin-top: 18px;
      }
    }
    h3 {
      margin-bottom: 0;
    }
    h4 {
      margin: 0; 
      font-size: 14px; 
      line-height: 1.5; 
      font-weight: normal;
      text-align: center;
      color: #a1aeb7;
    }
  }
}

@media only screen and (max-width: 1366px) {
  .masters {
    .studio-card {
      &:not(:last-child) {
        margin-right: 18px;
      }
    }
  }
}
</style>
